import { Injectable } from '@angular/core';
import { DatabaseProviderModel, AuthenticationTypeModel } from './connections.model';
import { GlobalService } from '../shared/services/global.service';

@Injectable()
export class ConnectionsService {

  constructor(
    private globalService: GlobalService) { }

  getDatabaseProviders(): DatabaseProviderModel[] {
    return [
      { code: 1, name: 'SQL Server' },
      { code: 2, name: 'Oracle' },
      { code: 3, name: 'Postgres' },
      { code: 4, name: 'MySQL' }
      // { code: 5, name: 'Microsoft Excel' }
    ];
  }

  getAuthenticationTypes(): AuthenticationTypeModel[] {
    return [
      { code: 1, name: 'Windows Authentication'},
      { code: 2, name: 'SQL Server Authentication' }
    ];
  }

  getConnections() {
    return this.globalService.httpGet('/Connections');
  }

}
